import React from 'react';
export function EyebrowSection() {
  return <div className="bg-brand-dark text-white py-2 px-4 text-center" data-id="element-227">
      <p className="text-xs md:text-sm text-gray-300 max-w-7xl mx-auto leading-relaxed" data-id="element-228">
        Professional-grade electric sprayers for contractors in mold
        remediation, sanitation, restoration, and facilities
        maintenance—designed to spray faster, safer, and without pumping or
        hauling chemicals.
      </p>
    </div>;
}